"use client";

// THE LAUNCH'S PRIMARY DOOR — the one door into innernet, the same everywhere
// (John, 2026-10-22: "the button on our signup page… the off-white and the
// white… rotating, but the cell inside never rotates. that's the sort of
// button i want"). It is THE pill in its SOLID voice (`btn-pill--solid`): an
// off-white capsule, the white disc, and netti's gradient mark in it
// (DoorMark). Only the petals turn on hover; the cell keeps its stance. It was
// a blue-gradient capsule for a day (`btn-pill--netti`, 2026-10-21); a door is
// never a filled gradient. Under it, centred, the quiet way to the developer
// page, marked with the code cell. Shared by the homepage and the developer page.

import DoorMark from "../../brand/DoorMark";
import { PillButton } from "../../ui";
import "./cta.css";

export function NettiCta({
  label,
  href,
  onClick,
  ariaLabel,
}: {
  label: string;
  href?: string;
  onClick?: () => void;
  ariaLabel?: string;
}) {
  const icon = <DoorMark className="hx-cta__mark" />;
  if (href) {
    return (
      <PillButton as="a" href={href} className="btn-pill--solid hx-door" icon={icon} aria-label={ariaLabel ?? label}>
        {label}
      </PillButton>
    );
  }
  return (
    <PillButton className="btn-pill--solid hx-door" icon={icon} aria-label={ariaLabel ?? label} onClick={onClick}>
      {label}
    </PillButton>
  );
}

/** the code cell: the brand cell holding a pair of angle brackets */
export function CodeCell({ size = 18 }: { size?: number }) {
  return (
    <svg className="hx-codecell" width={size} height={(size * 831) / 1071} viewBox="0 0 1071 831" aria-hidden>
      <path
        d="M497.334 1.16325C525.97 -1.07078 563.616 0.339061 592.556 1.8424C722.597 8.59791 864.623 37.6994 963.56 132.573C1033.39 199.542 1067.06 293.906 1070.48 391.556C1074.91 496.566 1051.64 601.094 981.706 679.447C878.328 795.279 718.684 823.838 574.817 830.23C545.368 831.517 513.973 830.964 487.114 829.81C354.565 824.096 207.321 795.212 106.747 697.848C36.2793 629.634 4.37501 538.346 0.473773 439.551C-3.70138 333.811 19.2046 230.374 89.6753 151.562C192.89 36.1332 353.651 7.30254 497.334 1.16325Z"
        fill="currentColor"
        opacity="0.18"
      />
      <path d="M420 290 300 415l120 125M651 290l120 125-120 125" fill="none" stroke="currentColor" strokeWidth="70" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** the door and, centred under it, the way to the developers */
export function CtaStack({
  signedIn,
  onBegin,
  devHref = "/developers",
  devLabel = "for developers",
  fine,
}: {
  signedIn: boolean;
  onBegin: () => void;
  devHref?: string;
  devLabel?: string;
  fine?: string | null;
}) {
  return (
    <div className="hx-cta">
      {signedIn ? (
        <NettiCta label="enter" href="/dashboard" ariaLabel="open your innernet" />
      ) : (
        <NettiCta label="create yours" onClick={onBegin} ariaLabel="create your innernet" />
      )}
      {devHref && (
        <a className="hx-cta__dev" href={devHref}>
          <CodeCell />
          <span>{devLabel}</span>
        </a>
      )}
      {fine !== null && !signedIn && <p className="hx-cta__fine">{fine ?? "free to start · no card"}</p>}
    </div>
  );
}

